import { render, staticRenderFns } from "./Segments.vue?vue&type=template&id=74997f7a"
import script from "./Segments.vue?vue&type=script&lang=js"
export * from "./Segments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports